import { MotionGlobalConfig } from 'motion-utils';
import { frameData } from './frame.mjs';

var _now;

function clearTime() {
  _now = undefined;
}
/**
 * An eventloop-synchronous alternative to performance.now().
 *
 * Ensures that time measurements remain consistent within a synchronous context.
 * Usually calling performance.now() twice within the same synchronous context
 * will return different values which isn't useful for animations when we're usually
 * trying to sync animations to the same frame.
 */


var time = {
  now: function now() {
    if (_now === undefined) {
      time.set(frameData.isProcessing || MotionGlobalConfig.useManualTiming ? frameData.timestamp : performance.now());
    }

    return _now;
  },
  set: function set(newTime) {
    _now = newTime;
    queueMicrotask(clearTime);
  }
};
export { time };